import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { Fab } from '@material-ui/core';

import { InfoMessage, TopActionBar } from '../../common/components';
import ResourceTaskContent from './components/ResourceTaskContent';
import { PrintIcon } from '../../common/icons';
import { headerHeight } from '../outside/components/Layout';

export const styles = theme => ({
    root: {
    },
    content: {
        minHeight: '80vh',
        padding: theme.spacing(2, 4),

        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(4),
        },
    },
    printFab: {
        display: 'none', // tmp..
        position: 'absolute',
        right: 0 + theme.spacing(2) + 70,
        top: headerHeight + theme.spacing(2),
        zIndex: 101,

        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
});

const Task = ({
    classes, translate, task, hasLoaded,
}) => {
    if (!task) {
        return hasLoaded ? (<InfoMessage messageKey="noContent" />) : null;
    }

    return (
        <div className={classes.root}>
            <TopActionBar
                title={task.name}
                backLink={{
                    // to: `${urls.inside.resource.module}/${task.moduleId}`,
                    // text: translate('resourceTask.backToModule', { module: task.moduleName }),
                    navigateBack: true,
                    text: translate('resourceTask.back'),
                }}
            />

            <div className={classes.content}>
                <Fab
                    onClick={() => window.print()}
                    className={classes.printFab}
                    color="primary"
                    title={translate('taskCommenting.print')}
                >
                    <PrintIcon />
                </Fab>

                <ResourceTaskContent
                    task={task}
                />
            </div>
        </div>
    );
};

Task.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    hasLoaded: PropTypes.bool.isRequired,
    task: PropTypes.object,
};

Task.defaultProps = {
    task: null,
};

const mapStateToProps = (state, ownProps) => {
    const itemId = ownProps?.match?.params?.taskId;
    const task = itemId && state.program.content && state.program.content[state.pageSettings.appConfig?.resourcesProgramId]?.modules
        ?.reduce((prev, curr) => {
            if (prev) return prev;
            const ct = curr.tasks?.find(d => d.id === itemId);
            if (ct) return { ...ct, moduleId: curr.id, moduleName: curr.name };
            return null;
        }
    , null);

    return {
        translate: getTranslate(state.localize),
        clientConfig: state.auth.clientConfig,
        hasLoaded: Boolean(state.program.content && state.program.content[state.pageSettings.appConfig?.resourcesProgramId]),
        task,
    };
};

export default connect(mapStateToProps)(withStyles(styles)(Task));
